import styled from 'styled-components'
import { space } from '@styled-system/space'
import themeGet from '@styled-system/theme-get'

export default styled.div`
  width: 4px;
  height: 4px;
  border-radius: 50%;
  background-color: ${themeGet('colors.softPeach')};

  ${space};
`
